"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var facebookTheme = {
  tenant: {
    primary: "#2477d7"
  }
};
var _default = exports["default"] = facebookTheme;